import { Sparkles } from 'lucide-react';
import clsx from 'clsx';

interface NewOnlyToggleProps {
  enabled: boolean;
  onChange: (enabled: boolean) => void;
  newCount?: number;
}

export function NewOnlyToggle({ enabled, onChange, newCount }: NewOnlyToggleProps) {
  return (
    <button
      onClick={() => onChange(!enabled)}
      className={clsx(
        'flex items-center space-x-2 px-4 py-2 rounded-lg border transition-all',
        enabled
          ? 'bg-brand-secondary text-brand-primary border-brand-secondary'
          : 'bg-white text-font-secondary border-card-border hover:border-brand-primary'
      )}
    >
      <Sparkles className="w-4 h-4" />
      <span className="font-medium">New Only</span>
      {newCount !== undefined && newCount > 0 && (
        <span
          className={clsx(
            'px-2 py-0.5 rounded-full text-xs font-semibold',
            enabled ? 'bg-brand-primary text-white' : 'bg-brand-secondary text-brand-primary'
          )}
        >
          {newCount}
        </span>
      )}
    </button>
  );
}
